import { render } from "./Mall of Egypt shops.vue?vue&type=template&id=0ff8c76a&scoped=true"
const script = {}

import "./Mall of Egypt shops.vue?vue&type=style&index=0&id=0ff8c76a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ff8c76a"

export default script